import React from 'react';
import './Welcome.css';
import HeaderSection from './HeaderSection';
import InfoCard from './InfoCard';
import { useNavigate } from "react-router-dom";
import MyFeatures from './Myfeature';
import Dashboard from './DashBoard';

function Welcome() {
     const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/trust"); 
  };
  return (
    <div className="welcome-container">
      <HeaderSection />
      <InfoCard handleNavigate={handleNavigate}/>
      <MyFeatures/>
      <Dashboard/>
    </div>
  );
}

export default Welcome;
